// import { ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { useState } from "react";
import { Card } from "react-bootstrap";

import "./Style.css";
// import axios from 'axios';

export default function ViewCredit({ showView, closeModal, refreshPage }) {
  const handleClose = () => {
    closeModal();
  };

  const [product, setProduct] = useState([
    {
        id: 1,
        customerName: "Joh Doe",
        duration: "1 Month",
        creditLine: "20,000,000",
        startDate: "11/10/2024",
        endDate: "12/11/2024",
    },
  ]);

  const productCards = product.map((product) => (
    <Card key={product.id} className="mb-3">
      <Card.Body>
        <Card.Title>{product.name}</Card.Title>
        <Card.Text>
          <strong>Customer Name:</strong> {product.customerName}
          <br />
          <strong>Duration:</strong> {product.duration}
          <br />
          <strong>Credit Line:</strong> {product.creditLine}
          <br />
          <strong>Start Date:</strong> {product.startDate}
          <br />
          <strong>End date:</strong> {product.endDate}
        </Card.Text>
      </Card.Body>
    </Card>
  ));

  return (
    <div className="ViewTransaction">
      <Modal show={showView} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>View Credit Details</Modal.Title>
        </Modal.Header>
        <Modal.Body  style={{ fontSize: "15px", lineHeight: "30px" }}>{productCards}</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleClose}>
            Close
          </Button>
          {/* <Button
            style={{ backgroundColor: "#c4281b" }}
            onClick={refreshPage}
          >
            Approved
          </Button> */}
        </Modal.Footer>
      </Modal>
    </div>
  );
}
